import Relation from '../relation/Relation'
import Friend from '../friend/Friend'
import Video from '../video/Video'

import './pages.css'

const Pages = ({data, isCurrent, isSetCurrent, isShow, isSetShow}) => {

      if(!isShow) return 

      const {relation, friends, videos} = data.user

      return (
            <div className={isShow ? "page_wrapper show" : "page_wrapper"}>
                  <div className="page_group">
                        <Relation relation={relation} isCurrent={isCurrent} isSetCurrent={isSetCurrent} isSetShow={isSetShow} />
                        <Friend friends={friends} isCurrent={isCurrent} isSetCurrent={isSetCurrent} isSetShow={isSetShow} />
                        <Video videos={videos} isCurrent={isCurrent} isSetCurrent={isSetCurrent} isSetShow={isSetShow} />
                  </div>
            </div>
      )
}

export default Pages
